<template>
  <div popup-mov v-if="movUrl" @click="close">
    <article >
      <a class="close" @click="close"></a>
      <iframe :src= "movUrl" width="100%" height="100%" frameborder="0" allow="autoplay;fullscreen allowfullscreen=">
      </iframe>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PopupMov',
  computed: {
    movUrl() {
      if (!this.$store.state.movUrl) return false;
      return `${this.$store.state.movUrl}?rel=0&amp;autoplay=1&amp;controls=1&amp;loop=0&amp;showinfo=0&amp;modestbranding=0&amp;disablekb=1&amp;enablejsapi=1`;
    },
  },
  methods: {
    close(e) {
      if (e) e.stopPropagation();
      this.$store.commit('offMov');
    },
  },
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{
    [popup-mov]{.fix; .t(0); z-index: 1000; .wh(100%); background:rgba(0,0,0,0.6);
      article{.wh(550,352); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%);
        a{.contain("@{pc}/btn-popup-close.png"); .block; .wh(51); .abs; .r(-60); .t(0); z-index: -1;  will-change: transform;
        }
      }
    }
  }
  .pc{
    [popup-mov]{ .fix; .t(0); z-index: 1000; .wh(100%); background:rgba(0,0,0,0.7);
      article{.wh(854px,480px); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%);
        a{.contain("@{pc}/btn-popup-close.png"); .block; .wh(87px); .abs; .r(-70px); .t(-40px); z-index: -1;  will-change: transform; transition: 1s;
          &:hover{transform: rotate(360deg);}
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupMov.vue